(function () {
  function formatMoney(cents) {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD' }).format((cents || 0) / 100);
  }

  function initBundleBuilder(root) {
    const rows = Array.from(root.querySelectorAll('[data-cf-row]'));
    const totalItemsEl = root.querySelector('[data-cf-total-items]');
    const totalWeightEl = root.querySelector('[data-cf-total-weight]');
    const totalPriceEl = root.querySelector('[data-cf-total-price]');
    const pricePerLbEl = root.querySelector('[data-cf-price-per-lb]');
    const errorEl = root.querySelector('[data-cf-error]');
    const successEl = root.querySelector('[data-cf-success]');
    const addButton = root.querySelector('[data-cf-add-bundle]');
    const minBoxes = Number(root.dataset.minBoxes || 3);
    const targetWeight = Number(root.dataset.targetWeight || 30);

    function clearMessages() {
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.add('cf-hidden');
      }
      if (successEl) {
        successEl.textContent = '';
        successEl.classList.add('cf-hidden');
      }
    }

    function getState() {
      let totalItems = 0;
      let totalWeight = 0;
      let totalPrice = 0;
      let qualifyingCount = 0;
      const items = [];

      rows.forEach((row) => {
        const qtyInput = row.querySelector('[data-cf-qty]');
        const qty = Number(qtyInput && qtyInput.value ? qtyInput.value : 0);
        const price = Number(row.dataset.price || 0);
        const weight = Number(row.dataset.weight || 0);
        const variantId = Number(row.dataset.variantId || 0);
        const qualifying = String(row.dataset.qualifyingBox) === 'true';

        if (qty > 0 && variantId) {
          totalItems += qty;
          totalWeight += qty * weight;
          totalPrice += qty * price;
          if (qualifying) qualifyingCount += qty;

          items.push({
            id: variantId,
            quantity: qty,
            properties: {
              _cf_bundle: 'true',
              _cf_weight_lb: String(weight),
              _cf_qualifying_box: qualifying ? 'true' : 'false'
            }
          });
        }
      });

      return { totalItems, totalWeight, totalPrice, qualifyingCount, items };
    }

    function render() {
      const state = getState();
      if (totalItemsEl) totalItemsEl.textContent = String(state.totalItems);
      if (totalWeightEl) totalWeightEl.textContent = String(state.totalWeight);
      if (totalPriceEl) totalPriceEl.textContent = formatMoney(state.totalPrice);
      if (pricePerLbEl) {
        const ppl = state.totalWeight > 0 ? state.totalPrice / state.totalWeight : 0;
        pricePerLbEl.textContent = formatMoney(ppl);
      }

      if (root.dataset.cfWeightHintTarget !== 'off') {
        root.querySelectorAll('.cf-stat').forEach((stat) => stat.classList.remove('cf-target-hit'));
      }
    }

    rows.forEach((row) => {
      const input = row.querySelector('[data-cf-qty]');
      if (input) input.addEventListener('input', render);
    });

    addButton.addEventListener('click', async function () {
      clearMessages();
      const state = getState();

      if (!state.items.length) {
        errorEl.textContent = 'Choose at least one item before adding your bundle to cart.';
        errorEl.classList.remove('cf-hidden');
        return;
      }

      if (state.qualifyingCount < minBoxes) {
        errorEl.textContent = `Choose at least ${minBoxes} qualifying boxes/items before checkout. You currently have ${state.qualifyingCount}.`;
        errorEl.classList.remove('cf-hidden');
        return;
      }

      try {
        addButton.disabled = true;
        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: state.items })
        });

        await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: {
            cf_bundle_box_count: String(state.qualifyingCount),
            cf_bundle_target_weight: String(targetWeight),
            cf_bundle_total_weight: String(state.totalWeight)
          } })
        });

        successEl.textContent = 'Your bundle has been added to cart.';
        successEl.classList.remove('cf-hidden');
        setTimeout(() => { window.location.href = `${window.Shopify.routes.root}cart`; }, 700);
      } catch (error) {
        console.error(error);
        errorEl.textContent = 'There was a problem adding this bundle to cart. Please try again.';
        errorEl.classList.remove('cf-hidden');
      } finally {
        addButton.disabled = false;
      }
    });

    render();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cf-bundle-builder]').forEach(initBundleBuilder);
  });
})();
